import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import { InsightsSummaryDataKpi } from '../../model/insights-summary-data-kpi.model';
import { SelectionChangeEvent } from '../../model/selection-change-event.model';
import { ViewSummaryPeriodType } from '../../model/view-summary-period-type.model';

import { TranslationKeyMap } from './navigation-bar.component.i18n';

@Component({
    selector: '[cmpsCoachingNavigationBar]',
    templateUrl: './navigation-bar.component.html',
})
export class CoachingNavigationBarComponent implements OnDestroy {
    @Input() kpis: InsightsSummaryDataKpi[];
    @Input() selectedPeriodType: ViewSummaryPeriodType;
    @Input() selectedKpi: InsightsSummaryDataKpi;
    @Output() selectionChange: EventEmitter<SelectionChangeEvent>;

    /** @private */ readonly _i18n = TranslationKeyMap;

    constructor() {
        this.selectionChange = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.selectionChange.complete();
    }

    /** @private */
    _onSelectClick(kpi: InsightsSummaryDataKpi): void {
        this.selectedKpi = kpi;

        this.selectionChange.emit({
            kpi: this.selectedKpi,
            periodType: this.selectedPeriodType,
        });
    }
}
